import { render, staticRenderFns } from "./NormalSimpleButton.vue?vue&type=template&id=369fe8a0&scoped=true&"
import script from "./NormalSimpleButton.vue?vue&type=script&lang=js&"
export * from "./NormalSimpleButton.vue?vue&type=script&lang=js&"
import style0 from "./NormalSimpleButton.vue?vue&type=style&index=0&id=369fe8a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369fe8a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
